module.exports = __webpack_public_path__ + "media/images/favicon-6935cda48636cd7476ca386de3c7f9ef.ico";